import React from 'react'
import { TaskDropdown } from '../TaskDropdown'
import { TaskActionButtonProps } from './TaskActionButton.types'
import './TaskActionButton.scss'

export const TaskActionButton: React.FC<TaskActionButtonProps> = ({
  icon,
  title,
  onClick,
  className,
  active,
  dropdownContent,
  dropdownOpen,
  onDropdownOpenChange,
  reserveBottom,
  instant,
}) => {
  const buttonEl = (
    <button
      className={`task-action-btn${active || dropdownOpen ? ' task-action-btn--active' : ''}${className ? ` ${className}` : ''}`}
      type="button"
      onClick={!dropdownContent ? onClick : undefined}
      aria-label={title}
    >
      {icon}
    </button>
  )

  if (dropdownContent) {
    return (
      <TaskDropdown
        open={dropdownOpen}
        onOpenChange={onDropdownOpenChange}
        side="bottom"
        align="end"
        alignToContainerRight={16}
        reserveBottom={reserveBottom}
        instant={instant}
        trigger={buttonEl}
      >
        {dropdownContent}
      </TaskDropdown>
    )
  }

  return buttonEl
}
